import { USER_LIST_SUCCESS, USER_LIST_FILTER_UPDATE, UPDATE_PENDING_USER_LIST_SUCCESS, USER_LIST_PAGE_UPDATE, COUNTRY_LIST_SUCCESS, ROLE_LIST_SUCCESS, REGION_LIST_SUCCESS, GET_USER_DETAILS_SUCCESS, SAVE_USER_DETAILS_SUCCESS, PENDING_USER_LIST_SUCCESS, REJECTED_USER_LIST_SUCCESS, UNMOUNT_EDIT_USER_SUCCESS, SHARE_LINK_BY_EMAIL_SUCCESS } from '../constants/constants';

export function UserReducer(state = {
    users: [],
    pendingusers: [],
    rejectedusers: [],
    filter: {
        logic: "and",
        filters: []
    },
    page: {
        skip: 0,
        take: 10
    },
    countries: [],
    roles: [],
    regions: [],
    editedUser: {},
    isSharedLink: false
}, action: any) {
    switch (action.type) {
        case USER_LIST_SUCCESS:
            return {
                ...state,
                users: action.payload.data.payload
            }
        case USER_LIST_FILTER_UPDATE:
            return {
                ...state,
                filter: action.payload
            }
        case USER_LIST_PAGE_UPDATE:
            return {
                ...state,
                page: action.payload
            }
        case COUNTRY_LIST_SUCCESS:
            return {
                ...state,
                countries: action.payload.data.payload
            }
        case ROLE_LIST_SUCCESS:
            return {
                ...state,
                roles: action.payload.data.payload
            }
        case REGION_LIST_SUCCESS:
            return {
                ...state,
                regions: action.payload.data.payload
            }
        case GET_USER_DETAILS_SUCCESS:
            return {
                ...state,
                editedUser: action.payload.data.payload
            }
        case SAVE_USER_DETAILS_SUCCESS:
            return {
                ...state,
                updatedUser: action.payload.data.payload
            }
        case PENDING_USER_LIST_SUCCESS:
            return {
                ...state,
                pendingusers: action.payload.data.payload
            }
        case UPDATE_PENDING_USER_LIST_SUCCESS:
            return {
                ...state
            }
        case REJECTED_USER_LIST_SUCCESS:
            return {
                ...state,
                rejectedusers: action.payload.data.payload
            }
        case UNMOUNT_EDIT_USER_SUCCESS:
            return {
                ...state,
                editedUser: action.payload
            }
        case SHARE_LINK_BY_EMAIL_SUCCESS:
            return {
                ...state,
                isSharedLink: action.payload.success
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer.user.tsx